import { bearerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const abnormalSecurity = defineConnector({
  identifier: "abnormalSecurity",
  name: "Abnormal Security",
  tagLine: "AI-based email security",
  logo,
  protocol: "http",
  tags: ["security"],
  defaultUrlPattern: () => "https://api\\.abnormalplatform\\.com/.*",
  auth: (app) => bearerAuth(app.secret.apiKey),
  steps: [
    {
      title: "Get an access token",
      items: [
        {
          kind: "markdown",
          content:
            "Log in to the [Abnormal Portal](https://portal.abnormalsecurity.com/), open **Settings > Integrations**, and connect the **Abnormal REST API** integration to reveal your access token.",
        },
      ],
    },
    {
      title: "Complete the IP safelist field",
      items: [
        {
          kind: "markdown",
          content:
            "Abnormal requires the REST API integration IP safelist to be configured before testing the connection. Review your current tenant info at `https://api.abnormalplatform.com/info` while completing the safelist.",
        },
      ],
    },
    {
      title: "Copy and paste the access token into the field below",
      items: [
        {
          kind: "input",
          label: "Abnormal Security access token",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: () => ({
      url: "https://api.abnormalplatform.com/v1/threats",
      headers: { "Mock-Data": "True" },
    }),
  },
});
